<template lang='pug'>
div
    div.fullwidth(v-if="$route.params.lang == 'en'")
        h1.title.secondary-header Services
        //- h2.subtitle What BSS can do for you
        div.margin-top-20.center-content
            router-link.service(to='/en/services/diagnostic-measurements')
                img( src='@/assets/svg/TransformerMeasurement.svg', alt='Diagnostic Measurements at Transformers', title='Diagnostic Measurements at Transformers')
                .link-title Diagnostic Measurements at Transformers and GIS
                p PD measurement and localization at transformers, GIS, and other assets in the test lab or on-site using different PD measurement methods 
            router-link.service(to='/en/services/hv-consulting')
                img( src='@/assets/svg/Consulting.svg', alt='PQ & Transient Measurements', title='PQ & Transient Measurements')
                .link-title Consulting & Studies
                p Consulting in high voltage issues and studies accompanying your development  
            router-link.service(to='/en/services/custom-devices')
                img( src='@/assets/svg/CustomDevices.svg', alt='Consulting & Studies', title='Consulting & Studies')
                .link-title Customized Measurement Devices
                p Development of individual measurement devices adapted to your requirements 

    div.fullwidth(v-if="$route.params.lang == 'de'")
        h1.title.secondary-header Dienstleistungen
        //- h2.subtitle What BSS can do for you
        div.margin-top-20.center-content
            router-link.service(to='/de/services/diagnostic-measurements')
                img( src='@/assets/svg/TransformerMeasurement.svg', alt='Diagnostische Messungen am Transformator', title='Diagnostische Messungen am Transformator')
                .link-title Diagnostische Messungen an Transformatoren und GIS
                p TE-Messung und Lokalisierung an Transformatoren, GIS und anderen Betriebsmitteln im Prüffeld oder vor Ort mit verschiedenen TE-Messmethoden 
            router-link.service(to='/de/services/hv-consulting')
                img( src='@/assets/svg/Consulting.svg', alt='PQ & Transienten-Messungen', title='PQ & Transienten-Messungen')
                .link-title Beratung und Untersuchungen
                p Beratung zu hochspannungstechnischen Fragestellungen und entwicklungsbegleitende Untersuchungen und Analysen 
            router-link.service(to='/de/services/custom-devices')
                img( src='@/assets/svg/CustomDevices.svg', alt='Beratung und Untersuchungen', title='Beratung und Untersuchungen')
                .link-title Individuelle Messtechnik
                p Entwicklung von an Ihre Anforderungen angepasster Messtechnik 

</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS - Dienstleistungen",
            description:
                "Alle Dienstleistungen der BSS Hochspannungstechnik GmbH",
        },
        en: {
            title: "BSS - Services",
            description: "Range of Services provided by BSS",
        },
    },
};
</script>

<style lang='sass' scoped>
.center-content
    width: 100%
    display: flex
    justify-content: space-between
    flex-wrap: wrap
    @media(max-width: $mobile-breakpoint)
        flex-direction: column
        align-items: center
.service
    display: flex
    flex-direction: column
    align-items: center
    width: 280px
    padding: 10px
    @media(max-width: $mobile-breakpoint)
        margin-bottom: 20px
    &:hover
        background-color: whitesmoke

    &:hover .link-title
        text-decoration: underline
    img
        width: 250px
    .link-title
        font-size: 1.2em
        height: 2.5em
        text-align: center
        margin-bottom: 1em
        #text
            text-align: center
    p
        text-align: center
        max-width: 100%
</style>